export enum pages {
	Order,
	ReviewOrder,
	CustomerInfo,
	Waiver,
	Pay,
	Receipt,
	ThankYou
}

export enum WaiverSteps
{
	email,
	password,
	guestSelection,
	addGuests,
	signWaiver
}

export enum CustomFieldType
{
	string,
	integer,
	decimal,
	boolean,
	dropdown
}
